//import { EstadoCuadreENUM } from '@/shared';
import * as yup from 'yup';


/* const itemSchema = yup.object().shape({
  correo: yup.string().required('El correo es campo obligatorio'),
}); */

export const newCuadreSchema = yup.object({
  bodega: yup.string().required('Bodega es requerido'),
  ubicacion: yup.string().required('Ubicación es requerido'),
  /* correos: yup
    .array()
    .of(itemSchema)
    .when('estado_cuadre', {
      is: (v: EstadoCuadreENUM) => v == EstadoCuadreENUM.FINALIZADO,
      then: (s) => s.required("Debe ingresar al menos un correo")
        .min(1, 'Debe agregar al menos un correo'),
      otherwise: (s) => s.notRequired(),
    }) */

})